// Closes a native <details> disclosure when the user clicks outside it or
// presses Escape, so summary-triggered menus behave like ordinary dropdowns.
// Usage: <details data-controller="details-autoclose">...</details>
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
    window.addEventListener("click", this.closeOnOutsideClick)
    window.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    window.removeEventListener("click", this.closeOnOutsideClick)
    window.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnOutsideClick(event) {
    if (this.element.open && !this.element.contains(event.target)) {
      this.element.open = false
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.element.open = false
    }
  }
}
